/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import UserSetupInsightsPerformanceSectionQuery from './__generated__/UserSetupInsightsPerformanceSectionQuery.graphql.ts';

type UserSetupInsightsEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const userSetupInsightsEntryPoint: EntryPoint<
	UserSetupInsightsEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<UserSetupInsightsEntryPointComponent>(
		/* webpackChunkName: "async-jira-admin-pages-performance-user-setup-insights", jiraSpaEntry: "async-jira-admin-pages-performance-user-setup-insights" */ './UserSetupInsightsPage.tsx',
	),
	getPreloadProps: ({ tenantContext, context }: EntryPointRouteParams) => {
		const nowMs = Date.now();
		const performanceEnd = new Date(nowMs);
		const performanceStart = new Date(nowMs - 24 * 60 * 60 * 1000);

		const dimensionName = context?.match?.params?.dimension ?? 'networkDownlink';
		const sortInput = [{ key: 'timestamp', order: 'ASC' as const }];

		return {
			queries: {
				performanceQuery: {
					parameters: UserSetupInsightsPerformanceSectionQuery,
					variables: {
						cloudId: tenantContext.cloudId,
						startDate: performanceStart.toISOString(),
						endDate: performanceEnd.toISOString(),
						granularity: 'HOUR' as const,
						dimensionInput: [{ name: dimensionName }],
						regionDimensionInput: [{ name: dimensionName }, { name: 'userCountry' }],
						configDimensionInput: [{ name: dimensionName }],
						sortInput,
					},
					options: {
						fetchPolicy: 'store-or-network' as const,
					},
				},
			},
		};
	},
});
